import { render, staticRenderFns } from "./IndividualDashboard.vue?vue&type=template&id=8d3acc08"
import script from "./IndividualDashboard.vue?vue&type=script&lang=js"
export * from "./IndividualDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports